import commercial from './modules/commercial';
import msgCenter from './modules/message-center';
import { protocolStore } from './modules/protocol';
import user from './modules/user';
export default {
  commercial,
  msgCenter,
  protocol: protocolStore,
  user,
};
